<template>
  <v-card class="elevation-0">
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>Notification</h4></v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-list two-line class="pa-0">
        <template v-for="(item, index) in items">
          <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
          <v-divider v-else-if="item.divider" :key="index"></v-divider>
          <v-list-tile avatar v-else :key="item.title" @click="handleClick(item)">
            <v-list-tile-avatar :color="item.color">
              <v-icon dark>{{item.icon}}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content class="mr-3">
              <v-list-tile-sub-title v-html="item.title"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action class="caption">
              {{ fromNow(item.time) }}
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
      <v-divider></v-divider>
      <v-btn block flat class="ma-0" @click="openAll()">All</v-btn>
      <v-divider></v-divider>
      <widget-dialog-notif></widget-dialog-notif>  
    </v-card-text>
  </v-card>
  
</template>

<script>
import moment from 'moment';
import WidgetDialogNotif from '../DialogNotif';

export default {  
  components: {
    WidgetDialogNotif,
  },      
  data: () => ({
    items: [],
    data : []
  }),
  created () {    
    this.getNotif();
    var context = this;
    window.setInterval(function(){
        context.getNotif();
    }, 1000);
  },
  methods: {
    handleClick(item) {
        if(item.ref.path){
            this.$router.push({path:item.ref.path, query:{flag:true}});
        }
    },
    
    openAll() {       
        window.getApp.$emit('APP_OPEN_DIALOG_NOTIF');
    },
    
    getNotif(){
        
        //window.getApp.$store.dispatch('entities/notifications/insert', {data : this.data});
        var notifs = window.getApp.$store.getters['entities/notifications/query']().orderBy('id', 'desc').limit(4).get();
        this.items = notifs
    },
    
    fromNow(time){
        return moment(time).fromNow();
    }
  },
};
</script>
